import { useState, useEffect, useRef } from 'react';

const FRAME_HEIGHT = 68;

const useStickyLinkbar = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [stickBarFixed, setStickyBarFixed] = useState<boolean>(false);

  const onScroll = () => {
    const top = ref?.current?.getBoundingClientRect().top;

    if (top && top <= FRAME_HEIGHT) {
      setStickyBarFixed(true);
    }

    if (top && top > FRAME_HEIGHT) {
      setStickyBarFixed(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return { ref, stickBarFixed };
};

export { useStickyLinkbar };
